import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SubscriptionDetail } from './subscription-detail.model';

@Component({
    selector: 'shared-subscription-detail',
    templateUrl: './subscription-detail.component.html',
    styleUrl: './subscription-detail.component.scss',
    standalone: false
})
export class SubscriptionDetailComponent {
  @Input({ required: true }) detail!: SubscriptionDetail;
  @Input() canCancel = true;
  @Output() readonly cancelSubscription = new EventEmitter<void>();

  onCancel(): void {
    this.cancelSubscription.emit();
  }
}
